<div>
  <formatDataValue [type]="'TEXT'" [value]="documentName">
  </formatDataValue>
  <span *ngIf="file">
    &lt;{{file.name}}&gt;
  </span>
</div>
<ng-container *ngIf="file">
  <ng-container *ngFor="let signature of signatures(file); let o = index">
    <div class="m-l-md">
      <a (click)="validateSignDocument(signature,file)">
        <img alt="image" style="width:20px" class="d-inline" src="assets/img/CERES.gif" />
        {{signature.date|date:'dd-MM-yyyy HH:mm'}}: {{signature.signer}}
        <ng-container *ngIf="signature.verification">
          <i *ngIf="isValidSignature(signature)" class="fa text-success fa-check" aria-hidden="true"></i>
          <i *ngIf="!isValidSignature(signature)" class="fas fa-exclamation-triangle text-warning"
            aria-hidden="true"></i>
        </ng-container>
      </a>
    </div>
  </ng-container>
</ng-container>